
import formValidation from '@/mixins/validation';

export default {
  name: 'FSlider',

  mixins: [formValidation],

  props: {
    label: {
      type: String,
      default: '',
    },
    hideLabelAppend: {
      type: Boolean,
      default: false,
    },
    labelAppend: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    color: {
      type: String,
      default: 'primary',
    },
    trackColor: {
      type: String,
      default: 'grey lighten-1',
    },
    thumbColor: {
      type: String,
      default: 'secondary lighten-4',
    },
    hideDetails: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    hasError: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    thumbLabel: {
      type: [Boolean, String],
      default: false,
    },
    rules: {
      type: Array,
      default: function rules() {
        const that = this;

        return [
          function (value) {
            return (
              that.isInRange(value, that.minimum, that.maximum) ||
              that.$t('outOfRangeError')
            );
          },
        ];
      },
      required: false,
    },
    maximum: {
      type: [Number, String],
      required: true,
    },
    minimum: {
      type: [Number, String],
      required: true,
    },
    labelFormatter: {
      type: [Boolean, Function],
      default: false,
    },
    step: {
      type: Number,
      default: 1,
    },
    prependIcon: {
      type: String,
      default: 'icon-minus-circle',
    },
    appendIcon: {
      type: String,
      default: 'icon-plus-2',
    },
    noControls: {
      type: Boolean,
    },
    sideTicks: {
      type: Array,
      default: () => [],
      required: false,
    },
  },

  computed: {
    isInvalid() {
      return (
        this.hasError || !this.isInRange(this.value, this.minimum, this.maximum)
      );
    },
    maximumValue() {
      return parseInt(this.maximum);
    },
    minimumValue() {
      return parseInt(this.minimum);
    },

    appendedLabel() {
      if (this.labelFormatter) {
        return this.labelFormatter(this.value);
      } else {
        return this.hideLabelAppend
          ? null
          : `${this.value} ${this.labelAppend}`;
      }
    },
  },

  methods: {
    decrement() {
      if (this.value > this.minimum) {
        this.$emit('input', this.value - this.step);
      }
    },

    increment() {
      if (this.value < this.maximum) {
        this.$emit('input', this.value + this.step);
      }
    },

    bubbleEvent(e) {
      this.$emit('input', e);
    },
  },
};
